var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 55,
    viewBox: "0 0 73 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5815 17.3658H64.2763L61.3916 5.47641C60.608 2.25206 57.8064 -0.00714111 54.5818 -0.00714111H18.4251C15.2005 -0.00714111 12.399 2.24491 11.6154 5.47641L8.7306 17.3658H8.42548C3.77933 17.3658 0 21.2622 0 26.0523V53.5558C0 54.3566 0.631044 55 1.40078 55H14.0355C14.8122 55 15.4363 54.3494 15.4363 53.5558V46.3207H57.5498V53.5558C57.5498 54.3566 58.1809 55 58.9506 55H71.5854C72.362 55 72.9861 54.3494 72.9861 53.5558V26.0523C72.9861 21.2622 69.2068 17.3658 64.5607 17.3658H64.5815ZM14.3406 6.1842C14.8122 4.24673 16.4904 2.8955 18.4251 2.8955H54.5818C56.5166 2.8955 58.1947 4.24673 58.6663 6.1842L61.3777 17.3658H11.6223L14.3337 6.1842H14.3406ZM2.80849 26.0523C2.80849 22.8565 5.32573 20.2613 8.42548 20.2613H64.5815C67.6812 20.2613 70.1984 22.8565 70.1984 26.0523V43.418H53.0424L50.4974 32.9371C50.3379 32.2936 49.7831 31.8432 49.1382 31.8432H23.8687C23.2238 31.8432 22.6621 32.2936 22.5095 32.9371L19.9646 43.418H2.80849V26.0523ZM23.5567 40.5297H49.4433L50.1437 43.4252H22.8563L23.5567 40.5297ZM24.2571 37.6342L24.9574 34.7387H48.0356L48.736 37.6342H24.2571ZM12.6347 52.1045H2.80849V46.3135H12.6347V52.1045ZM60.3653 52.1045V46.3135H70.1915V52.1045H60.3653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 33.5,
    r: 4.5,
    stroke: "#922349",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 33.5,
    r: 4.5,
    stroke: "#922349",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnAuto);
export default __webpack_public_path__ + "static/media/EnAuto.6a6301242d37ad12eb6a5ab3a37ed30a.svg";
export { ForwardRef as ReactComponent };